import { ApiService }             from '../../../api/api.service';
import { FileUploadOptionsModel } from './models/file-upload.options';
import { MessagesService }        from '../../../messages/messages.service';
import { S3OptionsModel }         from './models/s3-options';
import { SessionService }         from '../../../sessions/session.service';

export class FileUploadCtrl implements ng.IComponentController, ng.IOnDestroy, ng.IOnInit {
  acceptedTypes: string;
  file         : File;
  form         : ng.IFormController;
  options      : FileUploadOptionsModel;
  preview      : string;
  reader       : FileReader;
  s3BucketLink : string;
  uploadReady  = false;
  uploading    = false;

  imageExtensions = [
    'gif',
    'jpeg',
    'jpg',
    'png'
  ];

  constructor (
    private $element     : ng.IRootElementService,
    private $filter      : ng.FilterFactory,
    private $q           : ng.IQService,
    private $rootScope   : any,
    private $scope       : ng.IScope,
    private $state       : ng.ui.IStateService,
    private $translate   : ng.translate.ITranslateService,
    private messages     : MessagesService,
    private s3Upload     : any,
    private sessionObjAPI: SessionService,
    private workshopAPI  : ApiService
  ) {}

  $onDestroy () {
    this.$element.find('input[type="file"]')
    .off('change', this.handleChange);

    if (this.reader) {
      this.reader.removeAllListeners('load');
    }
  }

  $onInit () {
    this.preview = this.options.file;

    this.acceptedTypes = this.getAcceptedTypes();

    this.setupListener();
  }

  getAcceptedTypes () {
    switch (this.options.accept) {
      case 'images':
      default:
        return '.gif,.jpeg,.jpg,.png';
    }
  }

  getExtension ( filename : string ) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : ['png'];
  }

  handleChange ( e : JQuery.TriggeredEvent ) {
    const file = e.target.files[0];

    if (file.size > this.options.size) {
      angular.element(e.target).val(null);

      this.messages.show(`${ this.options.type }'s cannot exceed ${ this.prettifySize() }`, 'error');

      return;
    }

    if (this.options.accept === 'images' && this.imageExtensions.indexOf(this.getExtension(file.name)[0]) < 0) {
      angular.element(e.target).val(null);

      let message = `File must be one of the following types: `;

      for (let i = 0 ; i < this.imageExtensions.length ; i++) {
        message = message + `${ (this.imageExtensions[i]).toUpperCase() }${ i === this.imageExtensions.length - 1 ? '' : ',' } `;
      }

      this.messages.show(message, 'error');

      return;
    }

    this.$scope.$apply(() => {
      this.file = file;
    });

    this.reader = new FileReader();

    this.reader.addEventListener('load', this.handleReaderLoad.bind(this));

    this.uploadReady = true;

    this.reader.readAsDataURL(file);
  }

  handleReaderLoad ( e : any ) {
    this.$scope.$apply(() => {
      this.form.$setDirty();

      this.preview = e.target.result;
    });
  }

  isAdvertisement () {
    return this.options.type === 'advertisement';
  }

  prettifySize () {
    const mb = this.options.size / 1000000;

    if ( mb < 1 ) {
      const kb = mb * 1000;

      return `${ this.$filter('number')(kb) }KB`;
    }

    return `${ this.$filter('number')(mb) }MB`;
  }

  setupListener () {
    this.$element.find('input[type="file"]')
    .on('change', this.handleChange.bind(this));
  }

  showPreview () {
    return this.preview && !this.options.hidePreview;
  }

  upload () {
    this.uploading = true;

    this.workshopAPI.get('/company/s3_bucket_link')
    .then(data => {
      this.s3BucketLink = data;

      return this.isAdvertisement()
        ? this.workshopAPI.get('/workshop_admin/s3_signature_for_ad_v4')
        : this.workshopAPI.get('/company/s3_signature_v4', [ this.options.type, this.getExtension(this.file.name) ]);
    })
    .then(( options : S3OptionsModel ) => {
      const call = this.s3Upload(this.file, options);

      call.request.addEventListener('load', ( e : any ) => {
        if (e.target.status === 204) {
          return this.$q.when()
          .then(() => {
            return this.isAdvertisement()
            ? this.$q.when(true)
            : this.workshopAPI.post('/company/s3_path', {
              file_type: this.options.type,
              s3_link  : options.key
            });
          })
          .then(() => this.sessionObjAPI.refresh())
          .then(() => {
            this.uploading = false;

            if (this.options.saveRootScope) {
              this.$rootScope[this.options.type] = this.preview;
            }

            this.form.$setPristine();

            this.messages.show(this.$translate.instant('JS_SPACE.MESSAGES.UPLOAD_SUCCESSFUL'), 'success');

            this.$state.reload();
          })
          .catch(err => {
            this.uploading = false;

            this.messages.error(err);
          })
          .finally(() => {
            call.request.removeAllListeners('load');
          });
        }
      });

      call.request.addEventListener('error', ( e : any ) => {
        this.uploading = false;

        this.messages.show(e.target.responseText, 'error');

        call.request.removeAllListeners('error');
      });

      call.request.open('POST', this.s3BucketLink, true);
      call.request.send(call.fd);

    })
    .catch(err => {
      this.uploading = false;

      this.messages.error(err);
    });
  }
}